module.exports = __webpack_public_path__ + "img/tss-7.624d7bb1.jpg";